import LeagueCover from "../../shared/components/LeagueCover";
import InfoTooltip from "../../../../shared/components/InfoTooltip";
import { useCallback } from "react";
import Button from "../../../../shared/components/Button";
import { getLeague } from "../../shared/services/leagueService";
import { getLeagueTexts } from "../../shared/leagueTexts";
import { formatLeagueDate } from "../../shared/utils/leagueFormatting";
import { useLeagueResource } from "../../shared/hooks/useLeagueResource";
import LeagueFeedback from "../../shared/components/LeagueFeedback";
import LeagueLayout from "../../shared/components/LeagueLayout";
import LeagueLoadError from "../../shared/components/LeagueLoadError";

function LeagueDetails({ id }: { id: string }) {
  const t = getLeagueTexts();
  const load = useCallback(() => getLeague(id), [id]);
  const { data, loading, error, retry } = useLeagueResource(load);
  if (loading) return <LeagueFeedback>{t.loading}</LeagueFeedback>;
  if (error || !data) return <LeagueLoadError error={error || t.loadError} retry={retry} />;
  return <>
    <article className="league-panel">{data.imageUrl && <LeagueCover imageUrl={data.imageUrl} />}<h2 className="league-label-with-help">{data.name}<InfoTooltip content={t.foundation} ariaLabel={t.details} /></h2><p>{data.description}</p><p>{t.organizer}: {data.organizerName}</p><p>{data.venue ? `${t.venue}: ${data.venue}` : t.noVenue}</p>
      <p>{t.monthly}: {(data.monthlyAmountCents / 100).toFixed(2).replace(".", ",")}</p>
    </article>
    <div className="league-grid">{data.seasons.map(season => <article className="league-panel" key={season.id}>
      <h2>{t.season} {season.year}</h2>
      <p>{season.divisions.map(d => t[d.gender]).join(" · ")}</p>
      {season.periods.map(period => <p key={period.id}>{t.semester} {period.semester}: {formatLeagueDate(period.startsOn)} — {formatLeagueDate(period.endsOn)}</p>)}
    </article>)}</div>
    <article className="league-panel">{data.imageUrl && <LeagueCover imageUrl={data.imageUrl} />}<h2>{t.rules}</h2><p className="league-rules">{data.rulesText || t.missingRules}</p></article>
  </>;
}
export default function LeagueDetailsPage({ leagueId }: { leagueId: string }) {
  const t = getLeagueTexts();
  return <LeagueLayout><div className="league-actions"><Button href="#/ligas" variant="ghost">{t.back}</Button></div><LeagueDetails key={leagueId} id={leagueId} /></LeagueLayout>;
}
